import { makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) => ({
  radioButtonGroups: {
    marginTop: 12,
    marginBottom: 12,
  },
  tablePaperWrap: {
    position: 'relative',
    marginTop: 20,
    marginBottom: 20,
    maxWidth: 1110,
  },
  loadingWrap: {
    position: 'absolute',
    backgroundColor: 'rgba(255, 255, 255, 0.6)',
    width: '100%',
    height: '100%',
    zIndex: 2,
  },
  caption: {
    display: 'none',
  },
  paginationToolbar: {
    minHeight: 60,
  },
  contentId: {
    fontWeight: 500,
    fontSize: 12,
    color: '#666',
    paddingBottom: 4,
  },
  contentDesc1: {
    fontSize: 12,
    color: '#666',
  },
  contentLink: {
    fontSize: 12,
    color: '#777',
    textDecoration: 'underline',
  },
  contentDesc2: {
    fontSize: 11,
    color: '#aaa',
    lineHeight: 1.2,
  },
  contentDesc3: {
    fontSize: 11,
    color: '#666',
  },
  contentWriter: {
    fontWeight: 'bold',
    fontSize: 11,
    color: theme.palette.primary.main,
    backgroundColor: `${theme.palette.primary.main.toString()}10`,
    paddingLeft: 3,
  },
  contentSelectIcon: {
    marginTop: -1,
  },
  contentReviewStatus: {
    paddingTop: 2,
    paddingBottom: 3,
    fontWeight: 500,
    color: '#777',
    fontSize: 13,
  },
  contentEmphasize: {
    color: '#d0021b',
  },
  contentApproved: {
    color: theme.palette.primary.main,
  },
  contentReportedLink: {
    cursor: 'pointer',
  },
  contentReportedCount: {
    fontSize: 12,
    color: '#d0021b',
    fontWeight: 'bold',
  },
  crownIcon: {
    marginRight: 4,
  },
  contentReportReason: {
    display: 'flex',
    alignItems: 'center',
    fontSize: 12,
    color: '#d0021b',
  },
  contentNotePlaceholder: {
    justifyContent: 'flex-start',
    marginTop: -1,
    paddingLeft: 2,
    textAlign: 'left',
    lineHeight: 1.3,
    fontSize: 12,
  },
  contentNoteHasContent: {
    color: '#666',
  },
  tableCell80: {
    width: 80,
  },
  tableCell120: {
    width: 120,
  },
  tabelCellContent: {
    wordBreak: 'break-all',
    minWidth: 300,
    maxWidth: 440,
  },
  noResult: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: 13,
    color: '#aaa',
    width: '100%',
    height: 160,
    borderBottom: '1px solid #dbdbdb',
  },
  bannedUserTitleWrap: { marginBottom: 20 },
  bannedUserDescription: {
    paddingTop: 4,
    fontSize: 13,
    letterSpacing: 'normal',
    fontWeight: 500,
    color: '#999',
  },
  dimmed: {
    backgroundColor: 'rgb(250, 250, 250)',
    opacity: 0.3,
  },
}));

export default useStyles;
